const getSliceItem = (slice: string, itemKey: string) => {
  return (state: any) => state.getIn([slice, 'data', itemKey]);
};

export default getSliceItem;
